import * as React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { IUser } from '@nkr/models/index';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';
import { UserGroup } from '@nkr/enums/user-group';

export enum UserAction {
    Edit = 1,
    Delete = 2,
    ActivatePasswordExpiration = 3,
    ClearBlocks = 4,
    LockoutUser = 5,
    DeactivatePasswordExpiration = 6,
    UnlockUser = 7,
    None = 0
}

export const menuItemList = [
    { action: UserAction.Edit, title: 'Edit' },
    { action: UserAction.Delete, title: 'Delete' },
    { action: UserAction.ActivatePasswordExpiration, title: 'Activate Password Expiration (6mo)' },
    { action: UserAction.DeactivatePasswordExpiration, title: 'Deactivate Password Expiration' },
    { action: UserAction.ClearBlocks, title: 'Clear Login Blocks for User/IP Address' },
    { action: UserAction.LockoutUser, title: 'Lockout User Account' },
    { action: UserAction.UnlockUser, title: 'Unlock User Account' },
    { action: -1, title: '' }
];

interface IProps {
    isAdmin: boolean,
    isAdminLogin: boolean,
    userGroupId: UserGroup,
    currentUserGroupId: UserGroup,
    pullRight?: boolean,
    onMenuDisplayed?: (id: number) => void,
    onMenuToggle: (show: boolean) => void,
    onItemSelected: (id: number, action: number) => void
}

export class ActionButtonRenderer extends React.Component<ICellRendererParams & IProps, {}> {
    myDropdown: any = React.createRef();

    componentDidMount = () => {
        let self = this;
    }

    handleMenuToggle = (show: boolean) => {
        this.props.onMenuToggle(show);
    };

    handleMenuSelection = (id: any, action: number) => {
        this.props.onItemSelected(id, action);
    }

    getMenuItems = () => {
        const data = this.props.data as IUser;

        let menuItems = [];

        menuItems.push(UserAction.Edit);
        menuItems.push(-1);

        if (data.expirePasswordDateTime == '') {
            menuItems.push(UserAction.ActivatePasswordExpiration);
        } else if (this.props.userGroupId == UserGroup.Admin) {
            menuItems.push(UserAction.DeactivatePasswordExpiration);
        }

        if (data.isLockedOut || data.ipLoginFailureCount > 2 || data.lastLoginAttemptCount > 2) {
            menuItems.push(UserAction.ClearBlocks);
        }

        if (data.isLockedOut) {
            menuItems.push(UserAction.UnlockUser);
        }

        if (!data.isLockedOut) {
            menuItems.push(UserAction.LockoutUser);
        }

        if (!this.props.isAdmin && ((this.props.currentUserGroupId == UserGroup.CenterAdmin && this.props.userGroupId != UserGroup.CenterAdmin) || this.props.currentUserGroupId == UserGroup.Admin)) {
            menuItems.push(-1);
            menuItems.push(UserAction.Delete);
        }

        return menuItems;
    }

    render = () => {
        const dataLength = this.props.api.getModel().getRowCount();
        const dropup = dataLength <= 18 ? false : this.props.rowIndex + 1 > dataLength - 6;

        const menuItems = this.getMenuItems().map(item => {
            return menuItemList.find(x => x.action == item);
        });

        const menu = menuItems.map(item => {
            let id = item.action >= 0 ? this.props.data.id : 'div-' + this.props.data.id + '-' + Math.random() * 10000;

            if (item.action >= 0) {
                return { id, action: item.action, include: true, selectable: true, element: <>{item.title}</> };
            } else {
                return { id, action: item.action, include: true, selectable: false, element: <div style={{ height: 10 }}></div>, divider: true };
            }
        });

        return (
            <OverlayMenuButton
                menu={menu}
                bsStyle='primary'
                bsSize='xs'
                title='Actions'
                listItemStyle={{ padding: '2px 7.5px', fontSize: 14 }}
                includeCaret={true}
                onToggle={this.handleMenuToggle}
                onSelect={this.handleMenuSelection}
            />
        );
    }
}